/**
 * HERE address lookup expander for unified registration form.
 * PHP/jQuery era compatible (no ES6).
 */
;(function($) {
  'use strict';

  function getConfig() {
    var cfg = Storage.getData('here_geocode', {});
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    return cfg;
  }

  function translate(key) {
    if ($.translate) {
      return $.translate(key);
    }
    return key;
  }

  function appUrl(path) {
    var base = Storage.getData('app_url', '/');
    if (base.charAt(base.length - 1) !== '/') {
      base += '/';
    }
    return base + path.replace(/^\//, '');
  }

  function isEnabled() {
    var cfg = getConfig();
    return !!(cfg.enabled);
  }

  function RegisterAddressLookup($form) {
    this.$form = $form;
    this.$wrap = $form.find('.js-register-address');
    this.$toggle = this.$wrap.find('.js-address-lookup-toggle');
    this.$toggleLabel = this.$wrap.find('.js-address-lookup-toggle-label');
    this.$panel = this.$wrap.find('.js-address-lookup-panel');
    this.$input = this.$wrap.find('#register-address-lookup-q');
    this.$results = this.$wrap.find('.js-address-lookup-results');
    this.$msg = this.$wrap.find('.js-address-lookup-msg');
    this.$searchBtn = this.$wrap.find('.js-address-lookup-search');
    this.open = false;

    if (!this.$wrap.length || this.$wrap.attr('data-address-lookup') !== '1' || !this.$panel.length) {
      return;
    }

    this.bind();
  }

  RegisterAddressLookup.prototype.bind = function() {
    var self = this;

    this.$toggle.on('click', function(e) {
      e.preventDefault();
      if (!self.open && !isEnabled()) {
        alert(translate('Address lookup limit reached. Please fill the address manually.'));
        return;
      }
      self.setOpen(!self.open);
    });

    this.$searchBtn.on('click', function(e) {
      e.preventDefault();
      self.search();
    });

    this.$input.on('keydown', function(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        self.search();
      }
    });

    this.$results.on('click', '.js-address-lookup-pick', function(e) {
      e.preventDefault();
      var address = $(this).data('address');
      if (!address) {
        return;
      }
      self.applyAddress(address);
      self.$results.find('.js-address-lookup-pick').removeClass('is-selected');
      $(this).addClass('is-selected');
      self.setOpen(false);
    });
  };

  RegisterAddressLookup.prototype.setOpen = function(open) {
    this.open = !!open;
    this.$panel.toggleClass('hidden', !this.open);
    this.$toggle.toggleClass('is-open', this.open);
    this.$wrap.toggleClass('address-lookup-expanded', this.open);

    var label = this.open
      ? this.$toggle.attr('data-label-close')
      : this.$toggle.attr('data-label-open');
    if (label) {
      this.$toggleLabel.text(label);
    }

    if (this.open) {
      this.showMessage('');
      var self = this;
      setTimeout(function() {
        self.$input.focus();
      }, 50);
    } else {
      this.$results.empty();
      this.showMessage('');
    }
  };

  RegisterAddressLookup.prototype.showMessage = function(text) {
    if (!text) {
      this.$msg.addClass('hidden').text('');
      return;
    }
    this.$msg.removeClass('hidden').text(text);
  };

  RegisterAddressLookup.prototype.search = function() {
    var self = this;
    var q = $.trim(this.$input.val() || '');

    if (!isEnabled()) {
      this.showMessage(translate('Address lookup limit reached. Please fill the address manually.'));
      return;
    }

    if (q.length < 3) {
      this.showMessage(translate('Please enter a more complete address.'));
      return;
    }

    this.showMessage('');
    this.$results.empty();
    this.$searchBtn.prop('disabled', true);
    if (this.$searchBtn.button) {
      this.$searchBtn.button('loading');
    }

    $.ajax({
      url: appUrl('address-lookup/geocode'),
      type: 'POST',
      dataType: 'json',
      data: {
        q: q,
        csrf_token: self.$form.find('[name=csrf_token]').val(),
        csrf_token_name: self.$form.find('[name=csrf_token_name]').val()
      }
    }).done(function(response) {
      if (!response) {
        self.showMessage(translate('Address lookup failed. Please fill manually.'));
        return;
      }

      if (response.status !== 1) {
        self.showMessage(response.msg || translate('Address lookup failed. Please fill manually.'));
        return;
      }

      var results = response.results || [];
      if (!results.length) {
        self.showMessage(translate('No addresses found. Try a different query or fill manually.'));
        return;
      }

      self.renderResults(results);
    }).fail(function() {
      self.showMessage(translate('Address lookup failed. Please fill manually.'));
    }).always(function() {
      self.$searchBtn.prop('disabled', false);
      if (self.$searchBtn.button) {
        self.$searchBtn.button('reset');
      }
    });
  };

  RegisterAddressLookup.prototype.renderResults = function(results) {
    var self = this;
    this.$results.empty();

    $.each(results, function(_, item) {
      var label = item.label || (item.street + ', ' + item.city);
      var $btn = $('<button type="button" class="list-group-item js-address-lookup-pick"></button>');
      $btn.text(label);
      $btn.data('address', item);
      self.$results.append($btn);
    });
  };

  RegisterAddressLookup.prototype.applyAddress = function(address) {
    if (!address) {
      return;
    }

    var $street = this.$form.find('#user-auth-register-street');
    var $number = this.$form.find('#user-auth-register-number');
    var $city = this.$form.find('#user-auth-register-city');
    var $zip = this.$form.find('#user-auth-register-zip');
    var $country = this.$form.find('#user-auth-register-country');

    if ($street.length) {
      $street.val(address.street_name || address.street || '').trigger('change');
    }
    if ($number.length) {
      $number.val(address.street_number || '').trigger('change');
    }
    if ($city.length && address.city) {
      $city.val(address.city).trigger('change');
    }
    if ($zip.length && address.zip) {
      $zip.val(address.zip).trigger('change');
    }
    if ($country.length && address.country) {
      $country.val(address.country).trigger('change');
      if ($country.hasClass('select2-hidden-accessible') || $country.data('select2')) {
        $country.trigger('change.select2');
      }
    }
  };

  $(function() {
    var $form = $('#user-auth-register').find('form.js-register-form');
    if ($form.length && isEnabled()) {
      new RegisterAddressLookup($form);
    }
  });
})(jQuery);
